export default "__VITE_ASSET__B8FhVfyt__"